import React, { memo } from 'react';
import { string, number } from 'prop-types';
import Alert from '@active/react-ui/Alert';
import Locale from '@active/react-utils/i18n/Locale';
import { currency } from '../../../Currency';

const PaymentResultRefundInfo = ({
  totalAmount,
  currencyCode,
  locale,
}) => {
  if (totalAmount === undefined || totalAmount >= 0) {
    return null;
  }

  const values = {
    0: currency({
      amount: Math.abs(totalAmount),
      code: currencyCode,
      locale,
    }),
  };

  return <div className="payment-result__refund-info">
    <Alert theme="inline" className="cui-mg-t-20">
      <Locale id='checkout.lib.components.text.willBeRefunded' params={values} />
    </Alert>
  </div>;
};

PaymentResultRefundInfo.propTypes = {
  totalAmount: number.isRequired,
  currencyCode: string.isRequired,
  locale: string.isRequired,
};

export default memo(PaymentResultRefundInfo);
